import { render } from "./RouteDataUser.vue?vue&type=template&id=3eadd24e"
import script from "./RouteDataUser.vue?vue&type=script&lang=js"
export * from "./RouteDataUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__